import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import { getuserInfo } from '@/utils/auth'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/live',
        component: Layout,
        children: [{
            path: '/live',
            name: 'live',
            meta: {
                keepAlive: true
            },
            component: () => import('@/views/Live/index')
        }, {
            path: '/live/setup',
            name: 'setup',
            component: () => import('@/views/Live/setup')
        }]
    },
    {
        path: '/infor',
        component: Layout,
        children: [{
            path: '/infor',
            name: 'infor',
            component: () => import('@/views/Infor/index')
        }]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login/index')
    },
    {
        path: '/launch',
        name: 'launch',
        component: () => import('@/views/Launch/index')
    },
    {
      path: '/launch/login',
      name: 'launchLogin',
      component: () => import('@/views/LaunchLogin/index')
    },
    {
        path: '/watch',
        name: 'watch',
        component: () => import('@/views/Watch/index')
    },
    {
      path: '/watch/login',
      name: 'watchLogin',
      component: () => import('@/views/WatchLogin/index')
    },
    {
      path: '/UnAuthorize',
      name: 'UnAuthorize',
      component: () => import('@/views/UnAuthorize')
    }
]
if (getuserInfo()) {
    if (JSON.parse(getuserInfo()).is_admin) {
        routes.push({
            path: '/system',
            component: Layout,
            children: [{
                path: '/orgin',
                name: 'orgin',
                component: () => import('@/views/System/orgin')
            }, {
                path: '/orgin/application',
                name: 'application',
                component: () => import('@/views/System/application')
            }, {
                path: '/resource',
                name: 'resource',
                component: () => import('@/views/System/resource')
            }, {
                path: '/interface',
                name: 'interface',
                component: () => import('@/views/System/interface')
            }]
        }, {
            path: '/*',
            name: '404',
            component: () => import('@/views/404.vue')
        })
    } else {
        routes.push({
            path: '/application',
            component: Layout,
            children: [{
                path: '/application',
                name: 'application',
                component: () => import('@/views/System/application')
            }]
        }, {
            path: '/*',
            name: '404',
            component: () => import('@/views/404.vue')
        })
    }
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
